import React, { useState, useEffect, useRef } from 'react'
import { Row, Col, Button } from 'react-bootstrap';
import {  useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import { useReactMediaRecorder } from "react-media-recorder"
import { useUpdateQuestionWatchedMutation } from '../../slices/teachers/teacherQuestionsApiSlice';
import fixWebmDuration from 'webm-duration-fix';
import TeacherHeader from '../../components/TeacherHeader';
import TeacherNavbar from '../../components/TeacherNavbar';
import Loader from '../../components/Loader';
import Message from '../../components/Message';

const TeacherCamera = () => {

    const mimeType = 'video/webm\;codecs=vp9';

    const navigate = useNavigate();

    const { id } = useParams();

    const { studentInfo } = useSelector((state) => state.authStudent);

    const [updateQuestionWatched] = useUpdateQuestionWatchedMutation();

    const [showVideo, setshowVideo] = useState(false);
    const [showRecordButtons, setshowRecordButtons] = useState(true);
    const [showStopButtons, setshowStopButtons] = useState(false);

    const { teacherInfo } = useSelector((state) => state.authTeacher);

    useEffect(() => {
        if(!teacherInfo) {
            navigate('/teacherlogin')
        }
    }, [navigate, teacherInfo]);

    async function getString(mediaBlobUrl) {
        const mediaBlob = await fetch(mediaBlobUrl)
            .then(response => response.blob());
                const fixBlob = await fixWebmDuration(new Blob([mediaBlob], { type: mimeType }));                
                var fd = new FormData();
                fd.append('upl', fixBlob);
                fd.append('id', id);
                fetch('/api/upload/answer',
                {
                    method: 'post',
                    body: fd                
                });
    }

    const VideoPreview = ({ stream }) => {
        const videoRef = useRef(null);
        useEffect(() => {
          if (videoRef.current && stream) {
            videoRef.current.srcObject = stream;
          }
        }, [stream]);
        if (!stream) {
          return null;
        }
        return <video ref={videoRef}  autoPlay controls loop />;
    };

    const { status, startRecording, stopRecording, mediaBlobUrl, previewStream } = useReactMediaRecorder(
        { 
            video: true,
            screen: false, 
            onStart: () => {
                setshowStopButtons(true)
                setshowRecordButtons(false)
            },
            onStop: (blobUrl, blob) => {
                getString(blobUrl) 
                setshowVideo(true)
                setshowRecordButtons(false)
                setshowStopButtons(false)
                const res =  updateQuestionWatched(id).unwrap();
            }            
        });

    return (
        <div>
        <TeacherNavbar />
            <div className="main-content" id="panel">
            <TeacherHeader /><br />
                <div className="container-fluid mt--6">
                <div className="row">
                    {showRecordButtons ? ( 
                        <div>
                            <div className="offset-xl-1 col-xl-10">   
                                <h5 className="h3 card-title mb-0 mycard">
                                <h4 className="tittleColor4 recordTittle">
                                    Click on Record Cam  and give permission to the browser to acces your camera
                                </h4>
                                <br /> 
                                </h5>
                            </div>
                            <div className="offset-xl-4 col-xl-4 " onClick={startRecording}>   
                                    <div className="card rounded-pill mouseP">
                                        <div className="card-body recordVid33">
                                            <div className="row">
                                                <div className="sidenav-header recordButt33 col-xl-4" >
                                                    <img src="../../assets/img/rec3.png" className="navbar-brand-img recordButt33 recordButt34"  style={{ height: "100%"}}  />
                                                </div>
                                                <div className="col recordButton33 col-xl-8 ">
                                                    <span  className="h2 font-weight-bold mb-0 tittleColor4 recordButton33 recordVid339 ">
                                                        Record Cam
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                            </div>
                        </div>  
                    ) : ( 
                        <p></p>
                    )} 
                    {showStopButtons ? ( 
                        <div>
                            <div className="col-lg-8 offset-lg-2 "> <br /><br />
                                <div className="card mycard">
                                    <VideoPreview className="card-img-top"  stream={previewStream} />                                
                                    <div className="offset-xl-3 col-xl-6" onClick={stopRecording}>   <br />
                                        <div className="card rounded-pill  mouseP recArea2">
                                            <div className="card-body">
                                                <div className="row">
                                                    <div className="sidenav-header  recordButt33 col-xl-4" >
                                                        <img src="../../assets/img/stop1.png" className="navbar-brand-img recordButt33 re"  style={{ height: "90%"}}  />
                                                    </div>
                                                    <div className="col   col-xl-8 stopR">
                                                        <span  className="h5 font-weight-bold mb-0  tittleColor4  stopRec31">Stop recording</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>  
                    ) : ( 
                        <p></p>
                    )}
                    {showVideo ? ( 
                        <div className="col-lg-8 offset-lg-2 "> <br /><br />                      
                            <div className="card mycard">
                                <video className="card-img-top" src={mediaBlobUrl} controls autoPlay loop />
                                <div className="card-body "><br />  
                                    <LinkContainer to={`/teacheranswertype/${id}`} className='btn btn-warning '>
                                        <Button variant="primary  bg-gradient-danger" className=' btn btn-primary btn-lg  rounded-pill bg-gradient-info' > &nbsp; Record Again &nbsp; </Button>
                                    </LinkContainer>&nbsp; &nbsp;
                                    <LinkContainer to={`/teachernewquestions`} className='btn btn-success '>
                                        <Button variant="primary  bg-gradient-primary" className=' btn btn-primary btn-lg  rounded-pill bg-gradient-primary'>&nbsp; Save Video &nbsp; </Button>
                                    </LinkContainer><br />  
                                </div>
                            </div>
                        </div>
                    ) : ( 
                        <p></p> )
                    }  
                </div>
                </div>
            </div>    
        </div>
    )
}

export default TeacherCamera
